var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M75 44L3.55107e-06 87.3013L7.33658e-06 0.698727L75 44Z","fill":"white"}));
}

PlayIcon.defaultProps = {"viewBox":"0 0 75 88","fill":"none"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
